<h1 matDialogTitle>
    {{
        'queue_bulk_add_items_title' | translate: {
            queueName: context.data.name
        }
    }}
</h1>

<mat-dialog-content uiDragAndDropFile
                    [fileBrowseRef]="browseTrigger"
                    [fileClearRef]="clearTrigger"
                    (fileChange)="onFileChange($event)"
                    (fileClear)="onClear()"
                    fileType=".csv"
                    class="bulk-add-modal-content"
                    data-cy="file-process-container">
    <div class="layout-row">
        <mat-form-field class="flex">
            <input [value]="fileName"
                   [placeholder]="'queue_bulk_add_input_placeholder' | translate"
                   [disabled]="loading$ | async"
                   [matTooltip]="!file ? ('queue_items_bulk_add_please_select_file' | translate) : file!.name"
                   matInput
                   readonly
                   data-cy="queue-bulk-add-file-name-input" />
        </mat-form-field>
        <div #clearTrigger>
            <button *ngIf="!!file"
                    [matTooltip]="'remove_file' | translate"
                    [disabled]="loading$ | async"
                    mat-icon-button
                    class="clear-file"
                    type="button">
                <mat-icon>cancel</mat-icon>
            </button>
        </div>

        <label #browseTrigger>
            <button [disabled]="loading$ | async"
                    mat-button
                    color="primary"
                    class="ui-upload-button"
                    data-cy="queue-bulk-add-upload-button"
                    type="button">
                <mat-icon>folder</mat-icon>
                <span translate
                      class="text-upper">
                    modal_action_browse
                </span>
            </button>
        </label>
    </div>
    <div class="layout-row">
        <mat-radio-group [attr.aria-label]="'queue_bulk_commit_type_aria' | translate"
                         [disabled]="(loading$ | async) || !!responseFailedItems.length"
                         [(ngModel)]="commitTypeOption">
            <mat-radio-button [value]="BulkCommitType.ProcessAllIndependently">
                {{'queue_bulk_add_input_ProcessAllIndependently' | translate}}
            </mat-radio-button>
            <mat-radio-button [value]="BulkCommitType.AllOrNothing">
                {{'queue_bulk_add_input_AllOrNothing' | translate}}
            </mat-radio-button>
        </mat-radio-group>
    </div>
    <ng-container *ngLet="{
        error: {
            client: !!parsed?.errors?.length,
            server: !!responseFailedItems.length
        },
        noData: !!parsed && !parsed?.data?.length,
        successful: !!parsed?.data?.length && !parsed?.errors?.length && !responseFailedItems.length
    } as state">
        <div *ngIf="state?.successful"
             class="mat-accordion">
            <div class="mat-expansion-panel-header">
                <span class="mat-content">
                    <span [matTooltip]="'queue_items_bulk_add_preview' | translate: {
                            fileName: fileName,
                            records: parsed?.data.length
                            }"
                          class="parse-msg parse-success mat-expansion-panel-header-title"
                          tabindex="0">
                        <mat-icon>check_circle</mat-icon>
                        {{
                            'queue_items_bulk_add_preview' | translate: {
                                fileName: fileName,
                                records: parsed?.data.length
                                }
                            }}
                    </span>
                </span>
            </div>
        </div>
        <mat-accordion *ngIf="!!state && !state.successful"
                       [displayMode]="'flat'">
            <mat-expansion-panel class="mat-elevation-z">
                <mat-expansion-panel-header tabindex="0">
                    <mat-panel-title *ngIf="!parsed; else parsedMessages"
                                     [matTooltip]="'queue_bulk_add_items_parse_help' | translate"
                                     class="parse-msg parse-warn">
                        <mat-icon>info_outline</mat-icon> {{ 'queue_bulk_add_items_parse_help' | translate }}
                    </mat-panel-title>
                    <ng-template #parsedMessages>
                        <mat-panel-title *ngIf="state.error.client; else noErrors"
                                         [matTooltip]="'queue_items_bulk_add_preview_errors' | translate: {
                                            fileName: fileName,
                                            errors: parsed?.errors.length
                                        }"
                                         class="parse-msg parse-err">
                            <mat-icon>warning</mat-icon>
                            {{ 'queue_items_bulk_add_preview_errors' | translate: {
                                        fileName: fileName,
                                        errors: parsed?.errors.length
                                    }
                            }}
                        </mat-panel-title>
                        <ng-template #noErrors>
                            <mat-panel-title *ngIf="state!.noData"
                                             [matTooltip]="'queue_items_bulk_add_no_rows_found' | translate"
                                             class="parse-msg parse-err">
                                <mat-icon>warning</mat-icon>{{ 'queue_items_bulk_add_no_rows_found' | translate }}
                            </mat-panel-title>
                        </ng-template>

                        <mat-panel-title *ngIf="state!.error.server"
                                         [matTooltip]="'queue_items_bulk_parsed_with_errors' | translate: { count: responseFailedItems.length }"
                                         class="parse-msg parse-err">
                            <mat-icon>warning</mat-icon>
                            {{ 'queue_items_bulk_parsed_with_errors' | translate: { count: responseFailedItems.length } }}
                        </mat-panel-title>
                    </ng-template>

                </mat-expansion-panel-header>
                <mat-divider aria-hidden="true"></mat-divider>
                <ul tabindex="0">
                    <li>
                        <h4>
                            {{ 'queue_bulk_add_items_parse_help_date_fields' | translate }}:
                        </h4>
                        <ul>
                            <li *ngFor="let date of helpInfo.supportedDateFormats">{{ date }}</li>
                        </ul>
                    </li>
                    <li>
                        <h4>
                            {{ 'queue_bulk_add_items_parse_help_priority' | translate }}:
                        </h4>
                        <ul>
                            <li *ngFor="let priority of helpInfo.priorityValues">{{ priority }}</li>
                        </ul>
                    </li>
                </ul>
            </mat-expansion-panel>
        </mat-accordion>
        <div *ngIf="parsed && !responseFailedItems.length"
             tabindex="0">
            <ng-container *ngIf="parsed!.errors.length > 0">

                <div class="layout-row">
                    <h5 class="err-list-header">
                        <span [matTooltip]="'queue_bulk_csv_row' | translate"
                              class="inline-err err-row"
                              translate>queue_bulk_csv_row</span>
                        <span [matTooltip]="'queue_bulk_err_type' | translate"
                              class="inline-err err-type"
                              translate>queue_bulk_err_type</span>
                        <span [matTooltip]="'queue_bulk_err_field' | translate"
                              class="inline-err err-field"
                              translate>queue_bulk_err_field</span>
                        <span [matTooltip]="'queue_bulk_err_code' | translate"
                              class="inline-err err-code"
                              translate>queue_bulk_err_code</span>
                    </h5>
                </div>
                <div class="layout-row">
                    <mat-divider aria-hidden="true"></mat-divider>
                </div>
                <div class="layout-row">
                    <mat-list class="err-list"
                              dense>
                        <cdk-virtual-scroll-viewport [style.height.px]="getScrollHeight(parsed!.errors.length)"
                                                     itemSize="40">
                            <ng-container *cdkVirtualFor="let err of parsed!.errors">
                                <mat-list-item class="mat-divider">
                                    <div [matTooltip]="err.row"
                                         class="inline-err err-row">
                                        {{ err.row }}
                                    </div>
                                    <div [matTooltip]="'queue_bulk_err_type_'+ err.type | translate"
                                         class="inline-err err-type">{{ 'queue_bulk_err_type_'+ err.type | translate}}
                                    </div>
                                    <div class="inline-err err-field">
                                        <ng-container *ngIf="err.field; else noFieldForError">
                                            {{ err.field }}
                                        </ng-container>
                                        <ng-template #noFieldForError>
                                            {{ 'global_n_a_label' | translate }}
                                        </ng-template>
                                    </div>
                                    <div [matTooltip]="'queue_bulk_err_code_'+ err.code | translate"
                                         class="inline-err err-code">{{ 'queue_bulk_err_code_'+ err.code | translate}}
                                    </div>
                                </mat-list-item>
                            </ng-container>
                        </cdk-virtual-scroll-viewport>
                    </mat-list>
                </div>
            </ng-container>
        </div>
        <div *ngIf="responseFailedItems.length"
             tabindex="0">
            <div class="layout-row">
                <h5 class="err-list-header">
                    <span [matTooltip]="'queue_bulk_csv_row' | translate"
                          class="inline-err err-row"
                          translate>queue_bulk_csv_row</span>
                    <span [matTooltip]="'queue_bulk_err_msg' | translate"
                          class="inline-err err-msg"
                          translate>queue_bulk_err_msg</span>
                </h5>
            </div>
            <div class="layout-row">
                <mat-divider aria-hidden="true"></mat-divider>
            </div>
            <div class="layout-row">
                <mat-list class="err-list"
                          dense>
                    <cdk-virtual-scroll-viewport [style.height.px]="getScrollHeight(responseFailedItems.length)"
                                                 itemSize="40">
                        <ng-container *cdkVirtualFor="let err of responseFailedItems">
                            <mat-list-item class="mat-divider">
                                <div [matTooltip]="err.row"
                                     class="inline-err err-row">
                                    {{ err.row }}
                                </div>
                                <div [matTooltip]="err.errorMessage"
                                     class="inline-err err-msg">{{ err.errorMessage }}</div>
                            </mat-list-item>
                        </ng-container>
                    </cdk-virtual-scroll-viewport>
                </mat-list>
            </div>
        </div>
    </ng-container>

</mat-dialog-content>

<mat-dialog-actions *ngLet="{
                        loading: loading$ | async
                    } as state"
                    align="end">
    <button mat-dialog-close
            mat-button
            type="button"
            data-cy="queue-bulk-add-cancel-button">
        {{ 'modal_action_cancel' | translate }}
    </button>
    <button *ngIf="responseFailedItems.length &&
                    commitTypeOption === BulkCommitType.ProcessAllIndependently"
            [spinnerButtonLoading]="state.loading"
            [disabled]="state.loading"
            (click)="onDownloadUnprocessedRows()"
            ui-spinner-button
            mat-flat-button
            type="button"
            color="primary"
            data-cy="download-unprocessed-rows-button">
        {{ 'queue_bulk_download_unprocessed_rows' | translate }}
    </button>
    <button *ngIf="!responseFailedItems.length"
            [spinnerButtonLoading]="state.loading"
            [disabled]="state.loading || disableSubmit"
            (click)="onSubmit()"
            ui-spinner-button
            mat-flat-button
            type="button"
            color="primary"
            data-cy="bulk-add-queue-items-button">
        {{ 'modal_action_upload' | translate }}
    </button>
</mat-dialog-actions>
